module.exports = __webpack_public_path__ + "static/owl_intro-2cefacf85defa24a8977fe1d391616d0.mp4";